<template>
  <radio-group v-model="model.target_authorised_devices" inline>
    <radio
      :title="$t('CampaignForm_Target_All')"
      :description="$t('CampaignForm_Target_All_Description')"
      :label="0"
      data-qa="devices-target-everyone-option-radio"
      border
    />
    <radio
      :title="$t('CampaignForm_Target_Authorised')"
      :description="$t('CampaignForm_Target_Authorised_Description')"
      :label="1"
      data-qa="devices-target-authorised-option-radio"
      border
    />
  </radio-group>
</template>

<script>
import RadioGroup from '@/common/components/form/RadioGroup'
import Radio from '@/common/components/form/Radio'

export default {
  name: 'TargetDevices',

  components: { Radio, RadioGroup },
  props: {
    model: {
      default: 0
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/segment/TargetDevices.vue